<template>
  <vs-prompt
    :active.sync="showConfirmDialog"
    class="confirm-plan-prompt"
    buttons-hidden
    title="利用プラン変更"
    :color="AISEA_COLOR.BLACK"
  >
    <div class="w-full confirm-plan-dialog-area" style="position: relative">
      <div style="max-height: calc(100vh - 160px); overflow-y: auto">
        <div style="font-size: 16px">
          有料版のベーシックプランを利用開始します。
        </div>
        <div class="flex items-center mt-4">
          <span class="material-icons-outlined" style="font-size: 21px">
            info
          </span>
          <span class="ml-2"
            >プラン変更するにあたり、以下をご確認ください。</span
          >
        </div>
        <div class="p-4">
          <div class="mb-2">
            ・2カ月間の無料トライアル終了後に利用料金の請求が開始されます。
          </div>
          <div>・利用開始いただいた担当者様宛に請求書が送付されます。</div>
        </div>
      </div>
      <div class="flex justify-end items-center mt-4">
        <div class="button mr-4"
          :style="{ 'background-color' : AISEA_COLOR.WHITE, 'color' : AISEA_COLOR.BLACK } " 
          @click="closeConfirmDialog()"
          >キャンセル</div
        >
        <div 
          class="button" 
          :style="{ 'background-color' : AISEA_COLOR.BLUE } " 
          @click="startBasicPlan()"
          >利用開始</div
        >
      </div>
    </div>
  </vs-prompt>
</template>


<script>
import { DeviceInfoMixin, ColorMixin } from "@/mixins";
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("crewTier");


export default {
  mixins: [DeviceInfoMixin, ColorMixin],
  data () {
    return {
      showConfirmDialog: false,
    };
  },
  watch: {
  },
  computed: {
  },
  methods: {
    ...mapActions(["addTier3"]),
    async startBasicPlan () {
      // APIリクエスト
      const res = await this.addTier3();
      console.log(res);

      this.$vs.notify({
        title: `契約プラン`,
        text: `ベーシックプランに変更されました。`,
        color: "success",
        icon: "done"
      });
      this.closeConfirmDialog();
    },
    closeConfirmDialog () {
      this.showConfirmDialog = false;
    },
  }
};
</script>


<style lang="scss">
@import "src/assets/scss/aisea/variables";

.confirm-plan-prompt {
  .vs-dialog {
    max-width: 520px !important;
    margin: 10px;

    .vs-dialog-text {
      padding: 4px !important;
    }
    .vs-dialog-cancel {
      background-color: rgba(244, 244, 244, 0) !important;
      transform: none !important;
      box-shadow: none !important;
    }
  }
  .confirm-plan-dialog-area {
    padding: 12px;
  }

  .button {
    display: flex;
    width: 108px;
    height: 42px;
    border-radius: 6px;
    font-size: 14px;
    color: $aisea-white;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
}
</style>
